import { IconProps } from '../iconProps';

export const Dot = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className='lucide lucide-dot-icon lucide-dot'
    >
      <circle
        cx='12.1'
        cy='12.1'
        r='1'
      />
    </svg>
  );
};
